<div class="vertical-menu" [ngStyle]="sidebarStyle">

  <div data-simplebar class="h-100">

    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu">
        <li class="menu-title">{{'navigation.menu' | translate}}</li>
        <li>
          <a href="/dashboard/administrator" class="waves-effect">
            <i class="bx bx-home-circle"></i>
            <span>{{'navigation.home' | translate}}</span>
          </a>
        </li>
        <ng-container *ngIf="profile_id!=3">
        <li>
          <a href="javascript: void(0);" class="has-arrow waves-effect">
            <i class="bx bx-user"></i>
            <span>{{'navigation.users' | translate}}</span>
          </a>
          <ul class="sub-menu" aria-expanded="false" >
            <ng-container *ngIf="profile_id==11">
              <li><a href="/dashboard/administrator/clients">{{'navigation.siteAdministrators' | translate}}</a></li>
            </ng-container>
            <ng-container *ngIf="profile_id==11 || profile_id==1 || profile_id==12">
              <li><a href="dashboard/administrator/superviseurs">{{'navigation.supervisors' | translate}}</a></li>
            </ng-container>
            <ng-container *ngIf="profile_id==11 || profile_id==1 || profile_id==12 || profile_id==2 || profile_id==4 || profile_id==5 || profile_id==6 || profile_id==9 || profile_id==10">
              <li><a href="dashboard/administrator/verificateurs">{{'navigation.verifiers' | translate}}</a></li>
            </ng-container>
            <ng-container *ngIf="profile_id!=3">
              <li><a href="dashboard/administrator/intervenants">{{'navigation.learnersContributors' | translate}}</a></li>
            </ng-container>
          </ul>
        </li>
        </ng-container>
        <ng-container *ngIf="profile_id==11">
          <li>
            <a href="javascript: void(0);" class="has-arrow waves-effect">
              <i class="bx bx-briefcase-alt-2"></i>
              <span>{{'navigation.management' | translate}}</span>
            </a>
            <ul class="sub-menu" aria-expanded="false" >
              <li><a href="dashboard/administrator/verifications">{{'navigation.verifications' | translate}}</a></li>
              <li><a href="/dashboard/administrator/certifications">{{'navigation.certifications' | translate}}</a></li>
              <li><a href="dashboard/administrator/sous-certifications">{{'navigation.subCertificates' | translate}}</a></li>
              <li><a href="dashboard/administrator/choice_screen">{{'navigation.choiceScreen' | translate}}</a></li>
            </ul>
          </li>
        </ng-container>
        <ng-container *ngIf="profile_id==11 || profile_id==1 || profile_id==12">
          <li>
            <a href="/dashboard/administrator/formulaire">
              <i class="bx bxs-file-html"></i>
              <span>{{'navigation.forms' | translate}}</span>
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="profile_id==1 || profile_id==12">
          <li>
            <a href="/dashboard/administrator/import">
              <i class="bx bxs-cloud-upload"></i>
              <span>{{'navigation.imports' | translate}}</span>
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="profile_id!==3">
          <li>
            <a href="/dashboard/administrator/exports">
              <i class="bx bxs-cloud-download"></i>
              <span>{{'navigation.exports' | translate}}</span>
            </a>
          </li>
          <li>
            <a style="cursor: pointer;" (click)="verificateur_view(admin_login)">
              <i class="bx bx-log-in-circle"></i>
              <span>{{'navigation.connectAsVerifier' | translate}}</span>
            </a>
          </li>
          <li>
            <a style="cursor: pointer;" (click)="sso_certikap()">
              <i class="bx bx-log-in-circle"></i>
              <span>{{'navigation.connectLms' | translate}}</span>
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="profile_id==3">
          <li><a style="cursor: pointer;" (click)="viewCertificats(connected_id)"><i class='bx bxs-check-shield'></i><span>{{'navigation.myCertificates' | translate}}</span></a></li>
          <li><a style="cursor: pointer;" (click)="sso_active()"><i class="bx bx-book"></i><span>{{'navigation.myTraining' | translate}}</span></a></li>
        </ng-container>
      </ul>
    </div>
    <!-- Sidebar -->
  </div>
</div>
